import { Separator } from "@/components/ui/separator";
import { CarIcon, ChevronsDown } from "lucide-react";
import { Link } from "react-router-dom";

export const FooterSection = () => {
  return (
    <footer id="footer" className="container py-24 sm:py-10 overflow-x-hidden">
      <div className="p-10 bg-card border border-secondary rounded-2xl">
        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-x-12 gap-y-8">
          <div className="col-span-full xl:col-span-3">
            <Link to="/" className="font-bold text-lg flex items-center">
              <img
                src="/logo/logo-secondary.png"
                alt="MikroSell CarWash POS"
                className="h-9 mr-2"
              ></img>
            
            </Link>
            <p className="mt-2 text-muted-foreground">
              Revolutionize YourCar Wash Business with Our All-in-One POS
              Solution.
            </p>
          </div>

          {/* <div className="flex flex-col gap-2">
            <h3 className="font-bold text-lg">Services</h3>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Exterior Wash
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Interior Detailing
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Full-Service Wash
              </Link>
            </div>
          </div> */}

          <div className="flex flex-col gap-2">
            <h3 className="font-bold text-lg">Connect With Us</h3>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Facebook
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Instagram
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Twitter
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <h3 className="font-bold text-lg">Support</h3>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Contact Us
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                FAQ
              </Link>
            </div>
            <div>
              <Link to="#" className="opacity-60 hover:opacity-100">
                Feedback
              </Link>
            </div>
          </div>
        </div>

        <Separator className="my-6" />
        <section className="text-center">
          <h3>
            &copy; 2025
            <Link
              target="_blank"
              to="https://www.mikrosell.com"
              className="text-primary transition-all border-primary hover:border-b-2 ml-1"
            >
              MikroSell Systems
            </Link>
          </h3>
        </section>
      </div>
    </footer>
  );
};
